
import homeConfig from "@/apps/home/app.config"
//import myAppConfig from "@/apps/my-app/app.config"
import customLeftNav from "@/apps/custom-left-nav/app.config"
import supportConfig from "@/apps/tutorials/app.config"
import marginOpt from "@/apps/marginOpt/app.config";

//Order here corresponds to the order in the left navigation
var configs = [
    homeConfig,
    customLeftNav,
    //myAppConfig,
    supportConfig,
    marginOpt,
];


var registrationConfig = configs.map(e => {
    return {
        store: e.storeModule,
        route: e.route,
        navigation: {
            name : e.name,
            route : e.parentRoute,
            icon: e.icon,
            description : e.description,
            color : e.accentColor,
            children : e.navigation.map(nav => {
                return {
                    name : nav.title,
                    route : `${e.parentRoute}/${nav.route}`,
                    icon: nav.icon,
                }
            })
        }
    }
});

export default registrationConfig;
